"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToAnchor = void 0;
var scrollToElement_1 = require("./scrollToElement");
var DEFAULT_ANIMATION_TIME = 500;
var scrollToAnchor = function (_a) {
    var anchor = _a.anchor, offset = _a.offset, hasAnimation = _a.hasAnimation, _b = _a.hasRelocation, hasRelocation = _b === void 0 ? true : _b, _c = _a.timeout, timeout = _c === void 0 ? DEFAULT_ANIMATION_TIME : _c;
    // tslint:disable:no-any
    return function (event) {
        if (!event
            || !event.preventDefault
            || typeof window === 'undefined'
            || !window.location
            || !window.location.href
            || !(/^#\w+/.test(anchor))) {
            return;
        }
        event.preventDefault();
        (0, scrollToElement_1.scrollToElement)({ selector: anchor, offset: offset, hasAnimation: hasAnimation });
        if (hasRelocation) {
            setTimeout(function () { window.location.hash = anchor; }, timeout);
        }
    };
};
exports.scrollToAnchor = scrollToAnchor;
//# sourceMappingURL=scrollToAnchor.js.map